import React from 'react'
import ContactForm from '../components/ContactForm'

const cards = [
  { icon: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6', title: 'Send Us Mail', text: 'sewabharti1980@gmail.com' },
  { icon: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 012 2.21 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z', title: 'Call Us Anytime', text: '0184-2255874' },
  { icon: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z M12 10m-3 0a3 3 0 106 0 3 3 0 00-6 0', title: 'Visit Our Office', text: 'Sewa Bharti Haryana Pradesh\nSewa Shree Aashram, Valmiki Basti,\nArjun Gate, Karnal-132001 (Haryana)' },
]

export default function Contact() {
  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-2">
          <h1>Contact Us</h1>
          <p className="breadcrumb">Home › Contact Us</p>
        </div>
      </div>

      <section className="py-16" style={{background:'white'}}>
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((c, i) => (
            <div key={i} className="flex flex-col items-center text-center rounded-2xl p-8 mt-6 transition-all hover:-translate-y-1"
              style={{background:'white',border:'1px solid rgba(0,0,0,0.07)',boxShadow:'0 4px 20px rgba(13,27,62,0.06)'}}>
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 -mt-14 shadow-lg"
                style={{background:'linear-gradient(135deg,var(--saffron),var(--saffron-dark))'}}>
                <svg className="w-6 h-6" fill="none" stroke="white" strokeWidth="1.8" viewBox="0 0 24 24"><path d={c.icon}/></svg>
              </div>
              <h3 className="font-semibold text-base mb-2" style={{color:'var(--navy)'}}>{c.title}</h3>
              <p className="text-sm leading-relaxed whitespace-pre-line" style={{color:'var(--muted)'}}>{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      <ContactForm />
    </div>
  )
}
